type EphemeralSessionStorage = {
  'shared.api.fetch.headers'?: {
    'X-Language-Locale'?: string;
    'X-AT-CALLER'?: string;
  };
};

/**
 * setEphemeralData stores ephemeral data that exists in-memory only. This is meant for sharing state in a primitive, inelegant
 * way. It is not intended for persistent storage and should not be heavily used. It is meant for concerns that may not
 * play well outside React, like util files or other low level code where hooks and similar conventions are not usable.
 * This acts like a replacement to our historic uses of __AT_DATA__. It encapsulates the same concerns with an API.
 * When possible, avoid this, and use proper state management like Redux instead. Or props, contexts, etc.
 *
 * @param key
 * @param value
 */
export function setEphemeralData(key: keyof EphemeralSessionStorage, value: unknown) {
  if (!global.__AllTrailsStorage__) {
    global.__AllTrailsStorage__ = {};
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  global.__AllTrailsStorage__![key] = value;
}

/**
 * getEphemeralData retrieves ephemeral data that was persisted in-memory only
 *
 * @param key
 * @returns
 */
export function getEphemeralData(key: keyof EphemeralSessionStorage) {
  return global.__AllTrailsStorage__?.[key];
}

// deprecated
export const cacheSet = setEphemeralData;
// deprecated
export const cacheGet = getEphemeralData;
